'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable from "./com.raquo.airstream.core.-Base-Observable.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002e$002dSeq from "./com.raquo.laminar.-Seq.js";
import * as $j_com$002eraquo$002elaminar$002e$002dSeq$0024 from "./com.raquo.laminar.-Seq$.js";
import * as $j_com$002eraquo$002elaminar$002einserters$002e$002dDynamic$002dInserter from "./com.raquo.laminar.inserters.-Dynamic-Inserter.js";
import * as $j_com$002eraquo$002elaminar$002einserters$002e$002dInsert$002dContext$0024 from "./com.raquo.laminar.inserters.-Insert-Context$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction3$002e$0024$0024$002dLambda$002473f37e31ba038fe839c174212837da323f140c96 from "./scala.scalajs.runtime.-Anon-Function3.$$-Lambda$73f37e31ba038fe839c174212837da323f140c96.js";
var $p;
function $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__updateChildren__Lcom_raquo_ew_JsMap__Lcom_raquo_laminar_Seq__Lcom_raquo_ew_JsMap__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_laminar_nodes_ChildNode__I__O__I($thiz, prevChildren, nextChildren, nextChildrenMap, parentNode, sentinelNode, prevChildrenCount, hooks) {
  var index = new $j_java$002elang$002e$002dObject.$c_sr_IntRef(0);
  var currentChildrenCount = new $j_java$002elang$002e$002dObject.$c_sr_IntRef(prevChildrenCount);
  var prevChildRef = new $j_java$002elang$002e$002dObject.$c_sr_ObjectRef(sentinelNode.aV().nextSibling);
  var lastIndexChild = new $j_java$002elang$002e$002dObject.$c_sr_ObjectRef(sentinelNode);
  nextChildren.a6(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextChild) => {
    if ((currentChildrenCount.b6 <= index.b6)) {
      $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_nodes_ParentNode$().xq(parentNode, nextChild, lastIndexChild.aK, hooks);
      var ev$2 = nextChild.aV();
      prevChildRef.aK = ev$2;
      ev$2 = null;
      var ev$3 = ((1 + currentChildrenCount.b6) | 0);
      currentChildrenCount.b6 = ev$3;
    } else if ((!$j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(nextChild.aV(), prevChildRef.aK))) {
      if ((!(!(!prevChildren.has(nextChild.aV()))))) {
        $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_nodes_ParentNode$().xq(parentNode, nextChild, lastIndexChild.aK, hooks);
        var ev$4 = nextChild.aV();
        prevChildRef.aK = ev$4;
        ev$4 = null;
        var ev$5 = ((1 + currentChildrenCount.b6) | 0);
        currentChildrenCount.b6 = ev$5;
      } else {
        while (((!$j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(nextChild.aV(), prevChildRef.aK)) && (!$p_Lcom_raquo_laminar_inserters_ChildrenInserter$__containsRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Z($thiz, nextChildrenMap, prevChildRef.aK)))) {
          var nextPrevChildRef = prevChildRef.aK.nextSibling;
          $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_nodes_ParentNode$().Cl(parentNode, $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__prevChildFromRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Lcom_raquo_laminar_nodes_ChildNode($thiz, prevChildren, prevChildRef.aK));
          var ev$6 = nextPrevChildRef;
          prevChildRef.aK = ev$6;
          ev$6 = null;
          var ev$7 = ((currentChildrenCount.b6 - 1) | 0);
          currentChildrenCount.b6 = ev$7;
        }
        if ((!$j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(nextChild.aV(), prevChildRef.aK))) {
          $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_nodes_ParentNode$().xq(parentNode, nextChild, lastIndexChild.aK, hooks);
          var ev$8 = nextChild.aV();
          prevChildRef.aK = ev$8;
          ev$8 = null;
        }
      }
    }
    if ((prevChildRef.aK.nextSibling === null)) {
      var ev$9 = ((1 + index.b6) | 0);
      currentChildrenCount.b6 = ev$9;
    } else {
      var ev$10 = prevChildRef.aK.nextSibling;
      prevChildRef.aK = ev$10;
      ev$10 = null;
    }
    var ev$11 = nextChild;
    lastIndexChild.aK = ev$11;
    ev$11 = null;
    var ev$12 = ((1 + index.b6) | 0);
    index.b6 = ev$12;
  })));
  while ((index.b6 < currentChildrenCount.b6)) {
    var nextPrevChildRef$1 = prevChildRef.aK.nextSibling;
    $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_nodes_ParentNode$().Cl(parentNode, $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__prevChildFromRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Lcom_raquo_laminar_nodes_ChildNode($thiz, prevChildren, prevChildRef.aK));
    var ev$13 = nextPrevChildRef$1;
    prevChildRef.aK = ev$13;
    ev$13 = null;
    var ev$14 = ((currentChildrenCount.b6 - 1) | 0);
    currentChildrenCount.b6 = ev$14;
  }
  return currentChildrenCount.b6;
}
export { $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__updateChildren__Lcom_raquo_ew_JsMap__Lcom_raquo_laminar_Seq__Lcom_raquo_ew_JsMap__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_laminar_nodes_ChildNode__I__O__I as $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__updateChildren__Lcom_raquo_ew_JsMap__Lcom_raquo_laminar_Seq__Lcom_raquo_ew_JsMap__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_laminar_nodes_ChildNode__I__O__I };
function $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__containsRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Z($thiz, nextChildrenMap, ref) {
  return (!(!nextChildrenMap.has(ref)));
}
export { $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__containsRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Z as $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__containsRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Z };
function $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__prevChildFromRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Lcom_raquo_laminar_nodes_ChildNode($thiz, prevChildren, ref) {
  var x = prevChildren.get(ref);
  if ((x === (void 0))) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_Exception__T__(new $j_java$002elang$002e$002dObject.$c_jl_Exception(), ("prevChildFromRef[children]: not found for " + ref));
  }
  return x;
}
export { $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__prevChildFromRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Lcom_raquo_laminar_nodes_ChildNode as $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__prevChildFromRef__Lcom_raquo_ew_JsMap__Lorg_scalajs_dom_Node__Lcom_raquo_laminar_nodes_ChildNode };
/** @constructor */
function $c_Lcom_raquo_laminar_inserters_ChildrenInserter$() {
}
export { $c_Lcom_raquo_laminar_inserters_ChildrenInserter$ as $c_Lcom_raquo_laminar_inserters_ChildrenInserter$ };
$p = $c_Lcom_raquo_laminar_inserters_ChildrenInserter$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_inserters_ChildrenInserter$;
/** @constructor */
function $h_Lcom_raquo_laminar_inserters_ChildrenInserter$() {
}
export { $h_Lcom_raquo_laminar_inserters_ChildrenInserter$ as $h_Lcom_raquo_laminar_inserters_ChildrenInserter$ };
$h_Lcom_raquo_laminar_inserters_ChildrenInserter$.prototype = $p;
$p.Sn = (function(childrenSource, renderableSeq, renderableNode, initialHooks) {
  return new $j_com$002eraquo$002elaminar$002einserters$002e$002dDynamic$002dInserter.$c_Lcom_raquo_laminar_inserters_DynamicInserter($j_java$002elang$002e$002dObject.$m_s_None$(), true, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction3$002e$0024$0024$002dLambda$002473f37e31ba038fe839c174212837da323f140c96.$c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((ctx, owner, hooks) => {
    if ((!ctx.jG)) {
      ctx.xh();
    }
    return $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(childrenSource, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ctx$2) => ((components) => {
      this.XW(($j_com$002eraquo$002elaminar$002e$002dSeq$0024.$m_Lcom_raquo_laminar_Seq$(), new $j_com$002eraquo$002elaminar$002e$002dSeq.$c_Lcom_raquo_laminar_Seq(components, null, null)), ctx$2, hooks);
    }))(ctx)), owner);
  })), initialHooks);
});
$p.XW = (function(newChildren, ctx, hooks) {
  if ((!ctx.jG)) {
    ctx.xh();
  }
  var newChildrenMap = $j_com$002eraquo$002elaminar$002einserters$002e$002dInsert$002dContext$0024.$m_Lcom_raquo_laminar_inserters_InsertContext$().Wk(newChildren);
  ctx.iE = $p_Lcom_raquo_laminar_inserters_ChildrenInserter$__updateChildren__Lcom_raquo_ew_JsMap__Lcom_raquo_laminar_Seq__Lcom_raquo_ew_JsMap__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_laminar_nodes_ChildNode__I__O__I(this, ctx.hy, newChildren, newChildrenMap, ctx.jE, ctx.jF, ctx.iE, hooks);
  ctx.hy = newChildrenMap;
});
var $d_Lcom_raquo_laminar_inserters_ChildrenInserter$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_inserters_ChildrenInserter$, "com.raquo.laminar.inserters.ChildrenInserter$", ({
  i7: 1
}));
export { $d_Lcom_raquo_laminar_inserters_ChildrenInserter$ as $d_Lcom_raquo_laminar_inserters_ChildrenInserter$ };
var $n_Lcom_raquo_laminar_inserters_ChildrenInserter$;
function $m_Lcom_raquo_laminar_inserters_ChildrenInserter$() {
  if ((!$n_Lcom_raquo_laminar_inserters_ChildrenInserter$)) {
    $n_Lcom_raquo_laminar_inserters_ChildrenInserter$ = new $c_Lcom_raquo_laminar_inserters_ChildrenInserter$();
  }
  return $n_Lcom_raquo_laminar_inserters_ChildrenInserter$;
}
export { $m_Lcom_raquo_laminar_inserters_ChildrenInserter$ as $m_Lcom_raquo_laminar_inserters_ChildrenInserter$ };
